module.exports = {

	CHANGE_AMOUNT: 'CHANGE_AMOUNT',
	CHANGE_SYMBOL: 'CHANGE_SYMBOL',
	CHANGE_CODE: 'CHANGE_CODE',
	CHANGE_RECURRING: 'CHANGE_RECURRING',
	RP_MODAL_CLOSED: 'RP_MODAL_CLOSED',
	GIFT_AID_IT: 'GIFT_AID_IT',
	CHANGE_FORMATED_AMOUNT: 'CHANGE_FORMATED_AMOUNT',

	CHANGE_NOTE: 'CHANGE_NOTE',

	CHANGE_COUNTRY: 'CHANGE_COUNTRY',

	CHANGE_CARD_NUMBER: 'CHANGE_CARD_NUMBER',
	CHANGE_EXP_DATE: 'CHANGE_EXP_DATE',
	CHANGE_SECURITY_CODE: 'CHANGE_SECURITY_CODE',
	CHANGE_CARD_SPEC: 'CHANGE_CARD_SPEC',

	CHANGE_FIRST_NAME: 'CHANGE_FIRST_NAME',
	CHANGE_LAST_NAME: 'CHANGE_LAST_NAME',

	CHANGE_ADDRESS: 'CHANGE_ADDRESS',

	CHANGE_PHONE: 'CHANGE_PHONE',
	CHANGE_EMAIL: 'CHANGE_EMAIL',

	CHANGE_PASSWORD: 'CHANGE_PASSWORD',

	UPDATE_CONFIRMATION: 'UPDATE_CONFIRMATION',

	POST_BACK_DATA: 'POST_BACK_DATA',

	UPDATE_CURRENT_PAGE: 'UPDATE_CURRENT_PAGE',

	UPDATE_SERVER_ERRORS: 'UPDATE_SERVER_ERRORS',

	PAYMENT_ERROR: 'PAYMENT_ERROR',

	UPDATE_SIGN_UP_ERROR: 'UPDATE_SIGN_UP_ERROR',

	FUNDING_OPTIONS: 'FUNDING_OPTIONS',

	EMAIL: 'EMAIL',

	BILLING_ADDRESS: 'BILLING_ADDRESS',

	UPDATE_DONATION_AMOUNT_TYPE: 'UPDATE_DONATION_AMOUNT_TYPE',

	ENABLE_PRESET_AMOUNTS: 'ENABLE_PRESET_AMOUNTS',

	CHANGE_SHARE_ADDRESS: 'CHANGE_SHARE_ADDRESS',

	ADD_CARD_ERROR: 'ADD_CARD_ERROR',

	UPDATE_SELECTED_PROGRAM: 'UPDATE_SELECTED_PROGRAM',

	SAVE_FORM_DATA: 'SAVE_FORM_DATA',

	EMAIL_REX: /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/,

	DEFAULT_CARD_SPEC: {
		type: 'card',
		fields: {
			ccNumber: {
				required: true,
				pattern: '4[0-9]{12}(?:[0-9]{3})?',
				maxlength: 19
			},
			expirationDate: {
				required: true,
				pattern: '(0[1-9]|1[012])[\/]((20)[0-9]{2}|[0-9]{2})',
				maxlength: 7
			},
			csc: {
				required: true,
				pattern: '[0-9]*',
				maxlength: 3,
				minlength: 3
			}
		}
	},
	DONATE_GIFTAID_IT_EXTRA_AMOUNT: 1.25
};



// WEBPACK FOOTER //
// ./utility/constants.js